import { render, staticRenderFns } from "./companyRegisterNext.vue?vue&type=template&id=0995ae8c&"
import script from "./companyRegisterNext.vue?vue&type=script&lang=js&"
export * from "./companyRegisterNext.vue?vue&type=script&lang=js&"
import style0 from "./companyRegisterNext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports